// frontend/src/components/GallerySideNav/GallerySideNav.jsx
import React from 'react';
import styles from './GallerySideNav.module.css';
import HamburgerIcon from '../../assets/icons/HamburgerIcon';

const GallerySideNav = ({ albums, selectedAlbum, onSelectAlbum, isNavCollapsed, onToggleNav }) => {
  return (
    <aside className={`${styles.gallerySidebar} ${isNavCollapsed ? styles.gallerySidebarCollapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        {!isNavCollapsed && <h3 className={styles.sidebarTitle}>Albums</h3>}
        <button
          onClick={onToggleNav}
          className={styles.navToggleButton}
          aria-label={isNavCollapsed ? "Show navigation" : "Hide navigation"}
          aria-expanded={!isNavCollapsed}
        >
          <HamburgerIcon color="var(--text-dark-muted)" />
        </button>
      </div>

      {!isNavCollapsed && (
        <nav>
          <ul>
            {/* "All" Album Link */}
            <li>
              <button
                className={`${styles.albumLink} ${selectedAlbum === 'All' ? styles.activeLink : ''}`}
                onClick={() => onSelectAlbum('All')}
              >
                All
              </button>
            </li>

            {/* Links for each album */}
            {albums.map((album) => (
              <li key={album.title}>
                <button
                  className={`${styles.albumLink} ${selectedAlbum === album.title ? styles.activeLink : ''}`}
                  onClick={() => onSelectAlbum(album.title)}
                >
                  {album.title}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </aside>
  );
};

export default GallerySideNav;